import { useState } from 'react';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import OptionList, { IProps as IOptionListProps } from '@r1-frontend/ui-react/components/OptionList';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { IPriceOptionProps } from '~/src/entities/price';
import { EPriceOperationTypes } from '~/src/entities/price';

import { ISelectedPayOption, TConfirmParams } from './types';
import { usePriceOptions } from './usePriceOptions';

interface IProps extends Pick<IOptionListProps, 'reverseVariants' | 'onClickOptionChip'> {
    equipment: IEquipment,
    onConfirmSelect: (params: TConfirmParams) => void,
}

const TestDrivePurchase = ({
    equipment,
    onConfirmSelect,

    reverseVariants,
    onClickOptionChip,
}: IProps): JSX.Element | null => {
    const { testDrive } = equipment;

    const { priceOptions, testDriveOptions } = usePriceOptions(equipment);

    const [selectedOption, setSelectedOption] = useState<IPriceOptionProps>();
    const [selectedPayOptionId, setSelectedPayOptionId] = useState<ISelectedPayOption['optionId']>('');

    if (!testDrive || !testDriveOptions) {
        return null;
    }

    const selectOptionHandler = (optionId: string | number) => {
        setSelectedPayOptionId(optionId);

        const priceOption = priceOptions.find(el => Number(el.value) === Number(optionId));
        setSelectedOption(priceOption);
    };

    const confirmSelectHandler = () => {
        if (selectedOption) {
            onConfirmSelect({
                option: selectedOption,
                payOption: {
                    optionId: EPriceOperationTypes.TestDrive,
                    variantId: selectedPayOptionId,
                },
                testDriveOption: {
                    duration: testDrive.duration,
                    priceDuring: testDrive.priceDuring,
                },
            });
        }
    };

    return (
        <>
            <H3 $withIndent={false}>Выберите условия покупки оборудования после тест-драйва</H3>

            <ListContainer $direction={'column'} $wrap={'nowrap'} $size={16}>
                <OptionList
                    options={testDriveOptions.variants}
                    selectedOptionId={selectedPayOptionId}
                    selectedVariantId={''}
                    onClickOption={selectOptionHandler}
                    onClickOptionChip={onClickOptionChip}
                    reverseVariants={reverseVariants}
                />
            </ListContainer>

            <ButtonGroup>
                <Button size={'large'} bType={'action'} onClick={confirmSelectHandler}>Сохранить</Button>
            </ButtonGroup>
        </>
    );
};

export default TestDrivePurchase;
